import React, { Component } from 'react'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton'
import { withTranslation } from 'react-i18next'

class Error extends Component {

    render() {

        const { getErrorNotificationMessage, hasErrorNotification, ack, t } = this.props

        const actions = [
            <FlatButton
                label={t('visualizer:error.button')}
                primary={true}
                keyboardFocused={true}
                onClick={ack}
            />,
        ]

        return (
            <div>
                <Dialog
                    title={t(getErrorNotificationMessage)}
                    modal={true}
                    actions={actions}
                    open={hasErrorNotification}
                >
                </Dialog>
            </div>
        );
    }
}

export default withTranslation()(Error)
